// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1831":"bd904a5c","9367":"b536a0f1"}[chunkId] || chunkId) + "." + {"1831":"1baf7d6e6f5414d5","2813":"61d085ae7651d97c","3113":"a68e09c3c6551f75","3443":"4a5e6f709faef85a","3486":"d2b3f6dfb6af461f","6956":"78840f5d30911f7c","9367":"934f2eec1095d9dc","9746":"fa2f32ea57947197"}[chunkId] + ".js";
};